module.exports = __webpack_public_path__ + "img/doubleSideRectangularTrapezoidVertical.2a4c1341.svg";